import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "./lib/sentry";
import { captureAttribution } from "./lib/attribution";
import { registerServiceWorker } from "./lib/register-sw";

initSentry();
registerServiceWorker();

// First-touch attribution capture (issues #203/#204, cookie-based since #486).
// Runs on every entry, before any in-app navigation can strip the query
// string. Writes a strictly-necessary first-party cookie (not sessionStorage
// — the cookie survives the cross-subdomain hop from the marketing site's
// tristanoscatering.ca to this app's app.tristanoscatering.ca), scoped to
// that shared domain, capped at 90 days, sent to no third party; reads
// `location.search` only (never the hash, where recovery tokens live).
// Captures utm_*/gclid/fbclid and keeps the pixel's fbc builder in sync.
// Never throws. Respects cookie-consent (#486): if the visitor has declined
// (via this app's own banner OR the marketing site's — both write to the same
// shared consent cookie), no attribution is captured.
captureAttribution();

createRoot(document.getElementById("root")!).render(<App />);
